'use client';

import { Children, type ReactNode, useEffect, useState } from 'react';
import { Carousel } from 'react-bootstrap';

type WhyWeGiveCardsProps = {
  children: ReactNode;
};

export default function WhyWeGiveCards({ children }: WhyWeGiveCardsProps) {
  const [isMobile, setIsMobile] = useState<boolean | null>(null);
  const cards = Children.toArray(children);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  if (isMobile === null) {
    return null;
  }

  if (isMobile) {
    return (
      <Carousel
        indicators={true}
        controls={false}
        interval={3000}
        slide={true}
        fade={false}
        pause="hover"
        className="social-impact-why-carousel"
      >
        {cards.map((card, index) => (
          <Carousel.Item key={index}>{card}</Carousel.Item>
        ))}
      </Carousel>
    );
  }

  return (
    <div className="social-impact-card-grid social-impact-card-grid--three">
      {cards}
    </div>
  );
}
